<homey-custom-form [submitFunction]="submit" [formGroup]="form" submitButtonLabel="Submit">
  <homey-form-inputs class="mt-2">
    <homey-text-input
      [inputFormControl]="form.controls.oldPassword"
      [type]="{
      type: 'password',
      autocomplete: 'current-password'
    }"
      inputId="current-password"
      label="Current password"/>
    <homey-text-input
      [inputFormControl]="form.controls.newPassword"
      [type]="{
              type: 'password',
              autocomplete: 'new-password'
            }"
      inputId="new-password"
      [errorMessage]="passwordValidationErrorMessage"
      label="New password"
    />
  </homey-form-inputs>
</homey-custom-form>
